import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ForgeDeleteInterface } from "../../../middleware/interfaces/forge/forge-delete-interface";

export const ForgeDelete = {
  Delete: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const forgeDeleteData: ForgeDeleteInterface = state.data;
      const url = "./php/common/deleter-proxy.php";
      await axios
        .post(url, forgeDeleteData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
